import React, { useContext } from "react";
import { BottomNavigation, BottomNavigationAction, Box, Link, Typography } from "@mui/material";
import { BrandContext } from "../../contexts/BrandContext";


export default function BottomNav(){
    
    const brandContext = useContext(BrandContext);

    const  {
        textContent:{
            termsLink='',
            privacyPolicyLink='',
            copyrightLabel=''
        }
    } = brandContext;

    const navLinks = [
        {
            label:termsLink,
            path:'https://i-gtm.com/general-policies/terms-and-conditions/'
        },
        {
            label:privacyPolicyLink,
            path:'https://i-gtm.com/privacy-policy/'
        }
    ];

    return (
        <Box className="footerNavContainer">
            <Box className="footerNav">
                <Typography >{copyrightLabel}</Typography>
                {navLinks.map((navLink,index)=>(
                    <Link
                        href={navLink.path}
                        target="_blank"
                        key={index}
                    >
                        {navLink.label}
                    </Link>
                ))}
            </Box>
        </Box>
    );


}